module.exports = __webpack_public_path__ + "static/media/nory.9bd87a02.jpeg";